declare var tarteaucitron: any;
declare global {
    interface Window {
        tarteaucitronForceLanguage: string;
        opera: string;
        _paq: any;
    }
}

import {CorpusMenuService} from '@modules/corpus/core/services/corpus-menu.service';
import {Platform} from '@angular/cdk/platform';
import { NgClass } from '@angular/common';
import {Component, Inject, inject, OnDestroy, OnInit, DOCUMENT} from '@angular/core';
import {ExtendedModule} from '@angular/flex-layout';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatDialog, MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule, MatIconRegistry} from '@angular/material/icon';
import {MatSidenavModule} from '@angular/material/sidenav';
import {HammerModule, Title} from '@angular/platform-browser';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {AccountManagementProviderService} from '@modules/account-management';
import {AuthenticationService} from '@modules/authentication';
import {AuthorizationService} from '@modules/authorization';
import {BrowserTestService} from '@modules/browser-test';
import {CommunicationCenterService} from '@modules/communication-center';
import {LrsModule} from '@modules/lrs';
import {LangChangeEvent, TranslateModule, TranslateService} from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';
import {Angulartics2Matomo} from 'angulartics2';
import {FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule} from 'fuse-core/components';
import {FuseConfirmDialogComponent} from 'fuse-core/components/confirm-dialog/confirm-dialog.component';
import {MobileRedirectionModalComponent} from 'fuse-core/components/mobile-redirection-modal/mobile-redirection-modal.component';
import {FuseSidebarService} from 'fuse-core/components/sidebar/sidebar.service';
import {NewsModule} from 'fuse-core/news/news.module';
import {SnackbarNewsService} from 'fuse-core/news/snackbar/snackbar-news.service';
import {GlobalConfigurationService} from 'fuse-core/services/global-configuration.service';
import {LayoutConfigService} from 'fuse-core/services/layout-config.service';
import {FuseSplashScreenService} from 'fuse-core/services/splash-screen.service';
import {FuseTranslationLoaderService} from 'fuse-core/services/translation-loader.service';
import {FuseSharedModule} from 'fuse-core/shared.module';
import {LayoutConfig} from 'fuse-core/types';
import {capitalize} from 'lodash-es';
import {OctopusConnectService} from 'octopus-connect';
import {Observable, Subject} from 'rxjs';
import {timer} from 'rxjs/internal/observable/timer';
import {filter, map, take, takeUntil} from 'rxjs/operators';
import {LanguageService} from 'shared/language.service';
import {SharedTranslateModule} from 'shared/shared-translate.module';
import {isMobile} from 'shared/utils/navigator';
import {IsAllowedBySettings} from '../../../../src/app/guards';
import {HorizontalLayout1Module} from '../../../../src/app/layout/horizontal/layout-1/layout-1.module';
import {LayoutModule} from '../../../../src/app/layout/layout.module';
import {VerticalLayout1Module} from '../../../../src/app/layout/vertical/layout-1/layout-1.module';
import {
    brand,
    brandTitle,
    defaultLanguage,
    langs,
    matomoTrackingIDFromSettings,
    matomoTracking,
    mobileUrlRedirection,
    isMobileAlert,
    customLayoutConfig,
} from '../../../../src/app/settings/isc_lycee';
import {TralaTranslationLoaderService} from '../../../../src/app/trala-translation-loader.service';
import {TtsModule} from '../../../../src/app/tts/tts.module';
import {ServiceInstantiator} from './service-instantiator.class';
import {GroupsManagementInitializerService} from '@modules/groups-management/core/services/groups-management-initializer.service';
import {AssignationInitializerService} from '@modules/assignation/core/services/assignation-initializer.service';
import {AuthenticationConfigurationService} from '@modules/authentication/core/config/authentication-configuration.service';
import {AccessibilityService} from 'fuse-core/services/accessibility.service';
import {PrettyEasyMenuInitializerService} from './menu/pretty-easy-menu-initializer.service';

interface EditoData {
    titleDialog: string;
    bodyDialog: string;
    background?: string;
}

@Component({
    selector: 'app-root',
    imports: [
    ExtendedModule,
    FuseProgressBarModule,
    HorizontalLayout1Module,
    NewsModule,
    NgClass,
    TranslateModule,
    VerticalLayout1Module,
    SharedTranslateModule,
    MatMomentDateModule,
    MatExpansionModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatSidenavModule,
    MatDialogModule,
    MatBottomSheetModule,
    FuseSharedModule,
    FuseSidebarModule,
    FuseThemeOptionsModule,
    TtsModule,
    LayoutModule,
    LrsModule,
    HammerModule
],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
    protected title = 'isc-lycee';
    private lang: string;
    private browserLang: string;
    protected themeColor = 'red';
    protected layoutConfig: LayoutConfig;
    protected isAllowedSkipNavigation = false;
    protected brand: string = brand;
    private brandTitle: string = brandTitle;
    private matomoTrackingID: string = matomoTrackingIDFromSettings;
    private matomoTracking: boolean = matomoTracking;
    private _unsubscribeAll: Subject<void>;
    private languageService = inject(LanguageService);
    private route = inject(ActivatedRoute);
    private isRouteAccessible = inject(IsAllowedBySettings);
    private trackingInitialized = false;
    private router = inject(Router);
    private communicationCenter = inject(CommunicationCenterService);
    private authService = inject(AuthenticationService);
    private authorizationService = inject(AuthorizationService);
    private dialog = inject(MatDialog);
    private _layoutConfigService = inject(LayoutConfigService);
    private _fuseSidebarService = inject(FuseSidebarService);
    private _fuseSplashScreenService = inject(FuseSplashScreenService);
    private _fuseTranslationLoaderService = inject(FuseTranslationLoaderService);
    private _translateService = inject(TranslateService);
    private _platform = inject(Platform);
    private translationLoader = inject(TralaTranslationLoaderService);
    private _serviceInstantiator = inject(ServiceInstantiator);
    private browserTestService = inject(BrowserTestService);
    private matIconRegistry = inject(MatIconRegistry);
    private connector = inject(OctopusConnectService);
    private snackbarNews = inject(SnackbarNewsService);
    private usersProvider = inject(AccountManagementProviderService);
    private titleService = inject(Title);
    private angularticsMatomo = inject(Angulartics2Matomo);
    private corpusMenuService = inject(CorpusMenuService); // Inject CorpusMenuService to initialize it
    private groupsInitializer = inject(GroupsManagementInitializerService);
    private assignationInitService = inject(AssignationInitializerService);
    private AuthenticationConfiguration = inject(AuthenticationConfigurationService);
    private dataEdito: EditoData = null;
    private accessibilityService = inject(AccessibilityService);
    public globalConfigurationService = inject(GlobalConfigurationService);
    private prettyEasyMenuInitializerService = inject(PrettyEasyMenuInitializerService);

    constructor(
        @Inject(DOCUMENT) private document: Document,
    ) {
        this._unsubscribeAll = new Subject<void>();
        this.initNavigation();
        this.initLangManagement();
        this.initMobilePlatformManagement();
        this.initLayoutConfigManagement();
        this.corpusMenuService.initialize();
        this.groupsInitializer.initialize();
        this.assignationInitService.initialize();

        this.communicationCenter
            .getRoom('corpus')
            .getSubject('displayEmptyCorpusHelper')
            .next(true);

        this.communicationCenter
            .getRoom('authentication')
            .getSubject('userData')
            .subscribe((data) => {
                if (!this.trackingInitialized) {
                    this.initTracking();
                }
                if (data) {
                    Sentry.setUser({email: data.get('email')});
                    if (this.authService.isAtLeastTrainer()) {
                        this.communicationCenter
                            .getRoom('homePage')
                            .getSubject('enableCompassFeatures')
                            .next(true);
                        this.communicationCenter
                            .getRoom('homePage')
                            .getSubject('enableActualitiesFeatures')
                            .next(true);
                    }

                    this.communicationCenter
                        .getRoom('homePage')
                        .getSubject('enableCollectionFeaturesByRoles')
                        .next(['parent', 'learner']);
                    this.postAuthentication();
                } else {
                    this.postLogout();
                }
            });

        this.communicationCenter
            .getRoom('basicPage')
            .getSubject('displayBtnBackToHome')
            .next(true);
    }

    ngOnInit(): void {
        this.accessibilityService.init();
        this.prettyEasyMenuInitializerService.initializeMenu();
        this.communicationCenter.getRoom('edito').getSubject('showEdito').pipe(takeUntil(this._unsubscribeAll))
            .subscribe(launch => {
                this.showEdito(true);
            });

        this.router.events.pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                // if in whitelist array and is not authenticated
                if (!this.authService.isAuthenticated) {
                    const whiteListUrls = ['login', 'register', 'forgot-password'];
                    for (let i = 0; i < whiteListUrls.length; i++) {
                        if (window.location.href.indexOf(whiteListUrls[i]) > -1) {
                            !this.trackingInitialized ? this.initTracking() : null;
                        }
                    }
                }
            });

        this.document.body.classList.add(this.brand);
        this.document.querySelector<HTMLLinkElement>('link[ rel *= "icon"]').href =
            'assets/' + this.brand + '/favicon.png?v=6';
        this.setTitle(this.brandTitle);
        // Subscribe to config changes
        this._layoutConfigService.config$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {
                this.layoutConfig = config;

                if (this.layoutConfig.layout.width === 'boxed') {
                    this.document.body.classList.add('boxed');
                } else {
                    this.document.body.classList.remove('boxed');
                }
            });

        const requestIdle = (window as any)?.requestIdleCallback;
        if (typeof requestIdle === 'function') {
            requestIdle(() => {
                this.browserTestService.checkCompatibility();
            });
        } else {
            setTimeout(() => {
                this.browserTestService.checkCompatibility();
            }, 0);
        }
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    public setTitle(newTitle: string): void {
        this.titleService.setTitle(newTitle);
    }

    loadMatomo(trackingID: string): void {
        const matomoScript = document.createElement('script');
        matomoScript.setAttribute('type', `text/javascript`);
        let pushCommuneCode = '';
        let pushCollectiviteCode = '';
        let pushUaiCode = '';
        if (this.authService.userData) {
            if (
                this.authService.userData.get('collectivite')
                && this.authService.userData.get('collectivite').commune_code
                && this.authService.userData.get('collectivite').commune_code !== '') {
                const communeCode = this.authService.userData.get('collectivite').commune_code;
                if (communeCode) {
                    pushCommuneCode = `_paq.push(['setCustomDimension', 1, '${communeCode}']);`;
                }
            }
            if (
                this.authService.userData.get('collectivite')
                && this.authService.userData.get('collectivite').code
                && this.authService.userData.get('collectivite').code !== '') {
                const collectiviteCode = this.authService.userData.get('collectivite').code;
                if (collectiviteCode) {
                    pushCollectiviteCode = `_paq.push(['setCustomDimension', 2, '${collectiviteCode}']);`;
                }
            }
            if (this.authService.userData.get('sso_token')) {
                let ssoToken = this.authService.userData.get('sso_token');
                if (typeof ssoToken === 'string') {
                    ssoToken = JSON.parse(this.authService.userData.get('sso_token'));
                }
                if (ssoToken.hasOwnProperty('UAI')) {
                    pushUaiCode = `_paq.push(['setCustomDimension', 3, '${ssoToken.UAI}']);`;
                }
            }
        }
        matomoScript.innerText = `var _paq = window._paq || [];` + pushCommuneCode + pushCollectiviteCode + pushUaiCode + `_paq.push([\'enableLinkTracking\']);(function() {var u=\'https://matomo.tralalere.com/\';_paq.push([\'setTrackerUrl\', u+\'matomo.php\']);_paq.push([\'setSiteId\', \'${trackingID}\']);var d=document, g=d.createElement(\'script\'), s=d.getElementsByTagName(\'script\')[0];g.type=\'text/javascript\'; g.async=true; g.defer=true; g.src=u+\'matomo.js\'; s.parentNode.insertBefore(g,s);})();`;
        document.documentElement.firstChild.appendChild(matomoScript);
    }



    navigateToAnchor(event: Event) {
        event.preventDefault();
        const anchorId = 'maincontent';
        const element = document.getElementById(anchorId);

        if (element) {
            element.focus();
            element.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    }

    private initLayoutConfigManagement(): void {
        if (customLayoutConfig.hasOwnProperty('default')) {
            if (customLayoutConfig.hasOwnProperty(this.authService.accessLevel)) {
                this._layoutConfigService.setConfig(customLayoutConfig[this.authService.accessLevel], {emitEvent: true});
            } else {
                this._layoutConfigService.setConfig(customLayoutConfig['default'], {emitEvent: true});
            }

            this.communicationCenter
                .getRoom('authentication')
                .getSubject('userData')
                .subscribe(userData => {
                    const role = this.authService.accessLevel;
                    if (customLayoutConfig.hasOwnProperty(role)) {
                        this._layoutConfigService.setConfig(customLayoutConfig[role], {emitEvent: true});
                    } else {
                        this._layoutConfigService.setConfig(customLayoutConfig['default'], {emitEvent: true});
                    }
                });
        }
    }

    private initMobilePlatformManagement(): void {
        // Add is-mobile class to the body if the platform is mobile
        if (this._platform.ANDROID || this._platform.IOS) {
            this.document.body.classList.add('is-mobile');
        }
    }

    private initTracking(): void {
        // Matomo tracking
        if (this.matomoTracking) {
            this.loadMatomo(this.matomoTrackingID);
            this.angularticsMatomo.startTracking();
        }
    }

    private initLangManagement(): void {
        if (this.globalConfigurationService.getUseSelectedLangAsDefault()) {
            const defaultLang: string[] = langs.map((lang) => lang.id);
            this.browserLang =
                defaultLang.indexOf(navigator.language.substring(0, 2)) !== -1
                    ? navigator.language.substring(0, 2)
                    : defaultLanguage;

            // Add languages
            this._translateService.addLangs(defaultLang);

            // Set the default language
            this._translateService.setDefaultLang(this.browserLang);

            // Use a language
            this.lang = localStorage.getItem('lang') || this.browserLang;
            this.document.documentElement.lang = this.lang;
            this.connector.setLanguage(this.lang);
            this._translateService.use(this.lang);
            // Set the navigation translations
            this.translationLoader.loadTranslations(...defaultLang);
        } else {
            const lang = this.languageService.getActiveLanguage().id;
            this.document.documentElement.lang = lang;
            this.connector.setLanguage(lang);
            // Set the navigation translations
            this.translationLoader.loadTranslations(...this.languageService.availableLanguages.map((lang) => lang.id));
        }

        this._translateService.onLangChange.subscribe(
            (event: LangChangeEvent) => {
                this.connector.setLanguage(event.lang);
                this.document.documentElement.lang = event.lang;
                this._translateService.currentLang = event.lang;
            }
        );
        if (this.globalConfigurationService.getsubscribeToLanguageChange()) {
            this.checkIfQueryParamsForceLanguage();
            this.languageService.onLanguageChange$.subscribe((lang) => {
                // check route with access settings for new language
                this.isRouteAccessible.checkRouteAllowedOrRedirect(this.route.snapshot, this.router.routerState.snapshot);
            });
        }
    }

    private initNavigation(): void {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                const slugs = event.url.split('/').slice(1);

                const title = slugs
                    .map((slug) => `${capitalize(slug.split('?')[0])}`)
                    .join(' - ');
                this.setTitle(`${this.brandTitle} | ${title}`);
                this.isAllowedSkipNavigation = !(event.url.includes('register') || event.url.includes('login') || event.url.includes('password'));
            });
    }

    private postAuthentication(): void {
        this.dataEdito = null;
        if (this.AuthenticationConfiguration.settings.showEdito && this.authService.userData.get('collectivite')?.edito?.alias) {
            this.setDataEdito();
        }

        timer(1000).subscribe(() => {
            // isMobileAlert is used to show a msg mobile not supported but without redirection
            if (isMobile() && (mobileUrlRedirection || isMobileAlert)) {
                const dialogRef = this.dialog.open(
                    MobileRedirectionModalComponent,
                    {}
                );
                dialogRef.afterClosed().subscribe((result) => {
                    // isMobileAlert => no redirection only alert
                    if (result && !isMobileAlert) {
                        window.location.href = mobileUrlRedirection;
                    }
                });
            }
        });

        if (['trainer', 'learner', 'parent'].includes(this.authService.accessLevel)) {
            this.prettyEasyMenuInitializerService.setMenu(this.authService.accessLevel as 'trainer' | 'learner' | 'parent');
        } else {
            this.prettyEasyMenuInitializerService.setMenu('guest');
        }
    }

    private postLogout(): void {
        this.dataEdito = null;
        this.prettyEasyMenuInitializerService.setMenu('guest');
    }


    private checkIfQueryParamsForceLanguage(): void {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
            const queryParams = this.router.parseUrl(this.router.url).queryParams;
            const suggestedLanguageId = queryParams && queryParams['SuggestedLanguage'];

            // if there is no our query param, we don't need to do anything
            if (!suggestedLanguageId) {
                return;
            }
            const suggestedLanguage = this.languageService.availableLanguages.find(lang => lang.id === suggestedLanguageId);

            // if the language is already set, we don't need to do anything
            if (this.languageService.getActiveLanguage() === suggestedLanguage) {
                return;
            }
            this.languageService.setActiveLanguage(suggestedLanguage);

            // and now we remove the suggested language from the query params
            this.router.navigate([], {
                queryParams: {...queryParams, SuggestedLanguage: null},
                queryParamsHandling: 'merge'
            });
        });
    }


    private loadEdito(): Observable<EditoData | null> {
        return this.connector
            .loadEntity('pages', this.authService.userData.get('collectivite')?.edito?.alias)
            .pipe(
                take(1),
                map((res) => {
                    if (res.get('label') && res.get('body')) {
                        return {
                            titleDialog: res.get('label'),
                            bodyDialog: res.get('body'),
                            background: res.get('background'),
                        } as EditoData;
                    }
                    return null;
                })
            );
    }

    private setDataEdito(): void {
        this.loadEdito().pipe(take(1)).subscribe((data) => {
            if (data) {
                this.dataEdito = data;
            }
        });
    }

    private showEdito(force = false): void {
        if (this.dataEdito && this.dataEdito?.titleDialog && this.dataEdito?.bodyDialog) {
            this.openEditoDialog();
        } else if (force === true) {
            // first connexion case we force modal openning
            this.loadEdito().pipe(take(1)).subscribe((data) => {
                if (data) {
                    this.dataEdito = data;
                    this.openEditoDialog();
                }
            });
        }
    }

    private openEditoDialog(): void {
        if (this.dataEdito) {
            this.dialog.open(FuseConfirmDialogComponent, {
                data: this.dataEdito,
                panelClass: 'editorial-dialog-panel',
            });
        }
    }
}
